import { unwrapFlujosList } from './flujosEntradasMapper';

const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const firstDefined = (...values) => values.find((value) => value !== undefined && value !== null);

const isVisible = (row) => firstDefined(row.visible, row.activo, row.active, true) !== false;

export const normalizeFlujosVariedades = (response) =>
  unwrapFlujosList(response).map((row) => ({
    id: toNumber(row.id),
    codigo: firstDefined(row.codigo, row.code, row.cod_variedad, ''),
    nombre: firstDefined(row.nombre, row.name, row.descripcion, row.description, ''),
    visible: isVisible(row),
  }));

export const normalizeFlujosVariedadesNav = (response) =>
  unwrapFlujosList(response).map((row) => ({
    id: String(firstDefined(row.code, '')),
    codigo: String(firstDefined(row.code, '')),
    nombre: firstDefined(row.description, ''),
  }));

export const normalizeFlujosAlmacenes = (response) =>
  unwrapFlujosList(response).map((row) => ({
    id: toNumber(row.id),
    nombre: firstDefined(row.nombre, row.name, row.descripcion, row.description, ''),
    visible: isVisible(row),
  }));

export const normalizeFlujosPesos = (response) =>
  unwrapFlujosList(response).map((row) => ({
    id: toNumber(row.id),
    peso: toNumber(firstDefined(row.peso, row.value, row.valor)),
    visible: isVisible(row),
  }));

export const normalizeFlujosCajasPalet = (response) =>
  unwrapFlujosList(response).map((row) => ({
    id: toNumber(row.id),
    cajas: toNumber(firstDefined(row.cajas, row.value, row.valor)),
    visible: isVisible(row),
  }));
